import { z } from "zod";
/** Commercial declaration, never fiscal authority. Rates remain explicit fractions. */
export const priceCompositionChoiceSchema = z
    .object({
    ipi: z.enum(["ADD", "INCLUDED", "UNCONFIRMED"]),
    takeRate: z.enum(["APPLY", "INCLUDED", "KEEP_PUBLISHED"]),
    rate: z
        .string()
        .regex(/^0(?:\.\d{1,18})?$/)
        .optional(),
})
    .strict();
export const uploadPriceCompositionSchema = z
    .object({
    version: z.literal("PRICE_COMPOSITION_V1"),
    default: priceCompositionChoiceSchema.omit({ rate: true }),
    rows: z
        .array(z
        .object({
        row: z.number().int().min(2).max(5025),
        ...priceCompositionChoiceSchema.shape,
    })
        .strict())
        .max(5000),
})
    .strict()
    .superRefine((value, ctx) => {
    if (new Set(value.rows.map((entry) => entry.row)).size !== value.rows.length)
        ctx.addIssue({ code: "custom", path: ["rows"], message: "Duplicate Excel row declaration" });
});
export const receivedPriceSchema = z
    .object({
    version: z.literal("PRICE_COMPOSITION_V1"),
    amount: z
        .string()
        .regex(/^(?:0|[1-9]\d{0,30})(?:\.\d{1,80})?$/)
        .max(112),
    cell: z.string().min(1).max(200),
    scope: z.enum(["FILE", "ROW"]),
    ...priceCompositionChoiceSchema.shape,
})
    .strict();
//# sourceMappingURL=price-composition.js.map